import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-12 md:mt-20 mb-8 text-center" }
const _hoisted_2 = { class: "mb-1 text-md font-bold leading-tight" }
const _hoisted_3 = { class: "text-base-200" }
const _hoisted_4 = { class: "max-w-[914px] w-full" }
const _hoisted_5 = { class: "max-w-[300px] mx-auto" }
const _hoisted_6 = { class: "text-center mt-4" }
const _hoisted_7 = {
  key: 0,
  class: "max-w-[520px] mx-auto mt-12 md:mt-20"
}
const _hoisted_8 = { class: "text-info-900" }

import { computed, inject, ref } from 'vue';
import { AppConfigType, ScheduleType } from '~src/admin/types';
import Button from '../base/Button.vue';
import IconArrowLeft from '../icons/IconArrowLeft.vue';
import Card from '../layout/Card.vue';
import BaseSchedule from '../schedule/BaseSchedule.vue';
import { useRouter } from 'vue-router';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'Schedule',
  props: {
    schedule: {},
    isFirstSchedule: { type: Boolean }
  },
  emits: ["nextStep", "previousStep", "updateSchedule"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Router
const router = useRouter();

// Props


// Emits
const emit = __emit;

// Current schedule
const currentSchedule = ref<ScheduleType>(__props.schedule);

// Track articles left
const currentArticlesLeft = ref(0);

// Go to next step
const goToNextStep = () => {
    // Populate the keywords before the next step
    currentSchedule.value.articles_keywords = Array(7).fill([]);

    if (currentSchedule.value.advSchedule) {
        // Generate empty keywords for each time
        Object.entries(currentSchedule.value.advSchedule).forEach(([dayKey, dayValue]) => {
            currentSchedule.value.articles_keywords[Number(dayKey)] = Array(dayValue.length).fill([]);
        });
    }
    // Update the main schedule
    emit('updateSchedule', currentSchedule.value);

    // Go to next step and update the schedule
    emit('nextStep');
};

// Control the disabled state of the button
const canGoToNextStep = computed(() => {
    // First check if there are articles left
    if (currentArticlesLeft.value < 0) {
        return true; // Disable the button if no articles left
    }

    // Rhen check if anything is selected
    if (currentSchedule.value.advSchedule) {
        return Object.values(currentSchedule.value.advSchedule).reduce((sum, arr) => sum + arr.length, 0) === 0;
    } else {
        return currentSchedule.value.days.length === 0;
    }
});

// Set texts based on if schedule is first or not
let title = $gettext('When your first article should be published?');
let subtitle = $gettext('We will generate and publish article on your behalf on a given day and time.');

if (!__props.isFirstSchedule) {
    title = $gettext('When articles should be published?');
    subtitle = $gettext('We will generate and publish articles on your behalf on a given day and time.');
}

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref($gettext)('When your first article should be published?')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref($gettext)('We will generate and publish article on your behalf on a given day and time.')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseSchedule, {
        schedule: _ctx.schedule,
        onUpdateSchedule: _cache[0] || (_cache[0] = (newSchedule) => currentSchedule.value = newSchedule),
        onArticlesLeftUpdate: _cache[1] || (_cache[1] = (articlesLeft) => currentArticlesLeft.value = articlesLeft)
      }, null, 8, ["schedule"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Button, {
          class: "w-full",
          text: _unref($gettext)('Next'),
          size: "large",
          onClick: _withModifiers(goToNextStep, ["prevent"]),
          disabled: canGoToNextStep.value
        }, null, 8, ["text", "disabled"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Button, {
            text: _unref($gettext)('back to Subject'),
            size: "small",
            "has-background": false,
            type: "secondary",
            "icon-position": "left",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('previousStep')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(IconArrowLeft)
            ]),
            _: 1
          }, 8, ["text"])
        ])
      ]),
      (_unref(isAccountFree))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(Card, {
              "image-url": `${_unref(config).plugin_url}/public/images/first-schedule.png`,
              "image-alt": _unref($gettext)('Upgrade to premium plan')
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref($gettext)('On trial you can generate and publish only one article.')) + " ", 1),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    href: "#",
                    class: "underline underline-offset-[3px]",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_unref(router).push('/upgrade')), ["prevent"]))
                  }, _toDisplayString(_unref($gettext)('Upgrade')), 1),
                  _createTextVNode(" " + _toDisplayString(_unref($gettext)(
                                'to paid plan to publish articles more often - few times a day, on different hours.'
                            )), 1)
                ])
              ]),
              _: 1
            }, 8, ["image-url", "image-alt"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})